// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fh-7";
export var emphasizeQuantity = "_fh-3";
export var flatBottomCorners = "_fh-5";
export var productImage = "_fh-0";
export var quantityContainer = "_fh-2";
export var quantityHeader = "_fh-6";
export var tooltip = "_fh-1";
export var wrapAndEllipsesOverflow = "_fh-4";